import { z } from 'zod';
export const memoryCreateSchema = z.object({
    key: z
        .string()
        .min(1, 'Anahtar zorunludur')
        .max(255)
        .regex(/^[a-zA-Z0-9_.-]+$/, 'Anahtar sadece harf, rakam, _, . ve - içerebilir'),
    value: z.string().min(1, 'Değer zorunludur'),
    summary: z.string().max(200).optional(),
    category: z.string().max(100).optional().default('general'),
    tags: z.string().max(500).optional(),
    priority: z.coerce.number().int().min(1).max(5).optional().default(3),
});
export const memoryUpdateSchema = z.object({
    value: z.string().min(1).optional(),
    summary: z.string().max(200).optional(),
    category: z.string().max(100).optional(),
    tags: z.string().max(500).optional(),
    priority: z.coerce.number().int().min(1).max(5).optional(),
});
export const memoryRelationSchema = z.object({
    targetKey: z.string().min(1, 'Hedef anahtar zorunludur'),
    relationType: z.string().max(50).optional().default('related'),
});
export const memorySearchSchema = z.object({
    q: z.string().optional(),
    category: z.string().optional(),
    tag: z.string().optional(),
    page: z.coerce.number().int().positive().optional().default(1),
    perPage: z.coerce.number().int().positive().max(100).optional().default(50),
});
//# sourceMappingURL=memory.schema.js.map